import {http} from "@/api/http";
import {unwrapSuccess} from "@/api/helpers";

export async function currencies() {
    const res = await http.get('/dashboard/currencies');
    return unwrapSuccess(res);
}

export async function dashboard(currency, filter) {
    const res = await http.get(`/dashboard/${currency}`, {
        params: {...filter}
    });
    return unwrapSuccess(res);
}

export async function accounts(currency) {
    const res = await http.get(`/dashboard/accounts/${currency}`);
    return unwrapSuccess(res);
}